import reactPage from "./imgs/reactPage.png" 
import mdnPage from "./imgs/mdnPage.png"
import youtubePage from "./imgs/youtubePage.png";
import w3Page from "./imgs/w3Page.png"
export const data=[
    {
        id:1,
        img:reactPage,
        name:'React docs',
        link:"https://reactjs.org/"
    },
    {
        id:2,
        img:mdnPage,
        name:'MDN docs',
        link:"https://mdn.dev/"
    },
    {
        id:3,
        img:youtubePage,
        name:'YouTube',
        link:"https://www.youtube.com/results?search_query=react+js"
    },
    {
        id:4,
        img:w3Page,
        name:'W3 Schools',
        link:"https://www.w3schools.com/"
    }
]